<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { ONGOING_CAMPAIGN_EMPTY_STATE_CONTENT } from './CampaignEmptyStateContent';

import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import CampaignCard from 'dashboard/components-next/Campaigns/CampaignCard/CampaignCard.vue';

defineProps({
  title: {
    type: String,
    default: '',
  },
  subtitle: {
    type: String,
    default: '',
  },
});

const { t } = useI18n();
const localizedCampaigns = computed(() =>
  ONGOING_CAMPAIGN_EMPTY_STATE_CONTENT.map(campaign => ({
    ...campaign,
    title: t(
      `CAMPAIGN.EMPTY_STATE_EXAMPLES.LIVE_CHAT.${campaign.id}.TITLE`
    ),
    message: t(
      `CAMPAIGN.EMPTY_STATE_EXAMPLES.LIVE_CHAT.${campaign.id}.MESSAGE`
    ),
    inbox: {
      ...campaign.inbox,
      name: t('CAMPAIGN.EMPTY_STATE_EXAMPLES.LIVE_CHAT.INBOX_NAME'),
    },
    sender: {
      ...campaign.sender,
      name: t(
        `CAMPAIGN.EMPTY_STATE_EXAMPLES.LIVE_CHAT.${campaign.id}.SENDER`
      ),
    },
  }))
);
</script>

<template>
  <EmptyStateLayout :title="title" :subtitle="subtitle">
    <template #empty-state-item>
      <div class="flex flex-col gap-4 p-px">
        <CampaignCard
          v-for="campaign in localizedCampaigns"
          :key="campaign.id"
          :title="campaign.title"
          :message="campaign.message"
          :is-enabled="campaign.enabled"
          :status="campaign.campaign_status"
          :sender="campaign.sender"
          :inbox="campaign.inbox"
          :scheduled-at="campaign.scheduled_at"
          is-live-chat-type
        />
      </div>
    </template>
  </EmptyStateLayout>
</template>
